export default ({ request }) => ({
  // 获取项目选品记录明细
  getInfoProductApi(data = {}) {
    return request({
      url: '/digitalCenter/project/infoProduct/getProjectInfoProductList',
      method: 'post',
      data
    })
  },
  addInfoProductApi(data = {}) {
    return request({
      url: '/digitalCenter/project/infoProduct/addProjectInfoProduct',
      method: 'post',
      data
    })
  },
  // 删除项目单条选品记录
  delInfoProductApi(data = {}) {
    return request({
      url: '/digitalCenter/project/infoProduct/delProjectInfoProduct',
      method: 'post',
      data
    })
  },
  // 删除选择的多条项目选品记录接口
  delChoiceInfoProductApi(data = {}) {
    return request({
      url: '/digitalCenter/project/infoProduct/delChoiceProjectInfoProduct',
      method: 'post',
      data
    })
  },
  // 选品记录选择生成推荐单接口
  buildRecommendInfoProductApi(data = {}) {
    return request({
      url: '/digitalCenter/project/infoProduct/productBuildRecommend',
      method: 'post',
      data
    })
  },
  // 选品记录选择生成报价单接口
  buildQuotationInfoProductApi(data = {}) {
    return request({
      url: '/digitalCenter/project/infoProduct/productBuildQuotation',
      method: 'post',
      data
    })
  },
  // 选品记录更新客户选中标志接口
  updateCustomChoiceInfoProductApi(data = {}) {
    return request({
      url: '/digitalCenter/project/infoProduct/productUpdateCustChoice',
      method: 'post',
      data
    })
  },
  // 选品记录选择生成打样项目单
  buildProjectInfoProductApi(data = {}) {
    return request({
      url: '/digitalCenter/project/infoProduct/productBuildProject',
      method: 'post',
      data
    })
  },
  // 从购物车或收藏生成选品记录及推荐单接口
  buildRecommendFromCartOrCollectApi (data = {}) {
    return request({
      url: '/digitalCenter/project/infoProduct/cartOrCollectBuildRecommend',
      method: 'post',
      data
    })
  },
  // 从购物车或收藏生成选品记录及报价单接口
  buildQuotationFromCartOrCollectApi (data = {}) {
    return request({
      url: '/digitalCenter/project/infoProduct/cartOrCollectBuildQuotation',
      method: 'post',
      data
    })
  }
})
